import React from 'react';
import styled from 'styled-components';
import { maxWidth, retina, wMBold } from 'Utils/utilsStyle';
import LightBulb from '../assets/svgIcons/LightBulb';



type Props = {
  heading: string;
};
const StyledWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  svg{
    @media all and (max-width: ${maxWidth}) , ${retina} {
      max-height: 15px;
    }
  }
  .heading{
    color: #424B50;
    line-height: 47px;
    font-size: 22px;
    font-family: 'Roboto Slab';
    font-weight: ${wMBold};
    margin-left:18px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      line-height: 34px;
      font-size: 16px;
      margin-left:12px;
    }
  }
`;
const DrawerHeading = function DrawerHeading(props: Props) {
  const { heading } = props;
  return (
    <StyledWrapper>

      <LightBulb />

      <span className="heading">{heading}</span>
    </StyledWrapper>
  );
};

export default DrawerHeading;
